module.exports = __webpack_public_path__ + "img/supportiavivo.a5c12180.jpg";